import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'u2b-button-loading-indicator',
    template: '<ng-container *ngIf="state > 0">&bull;</ng-container><ng-container *ngIf="state > 1">&bull;</ng-container><ng-container *ngIf="state > 2">&bull;</ng-container>',
    styles: [
        ':host { display: inline-block; width: 25px; }'
    ],
    standalone: false
})
export class ButtonLoadingIndicatorComponent implements OnInit {
    public state = 0;

    public ngOnInit(): void {
        setInterval(() => {
            if (this.state < 4) {
                this.state++;
            } else {
                this.state = 0;
            }
        }, 400);
    }
}
